module.exports = __webpack_public_path__ + "img/sber.490297a5.png";